import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * 404 Not Found page
 */
export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-[var(--color-bg-muted)] mb-4">404</h1>
        <h2 className="text-lg font-semibold text-[var(--color-text)] mb-2">
          {t('core.notFound.title')}
        </h2>
        <p className="text-sm text-[var(--color-text-secondary)] mb-6">
          {t('core.notFound.body')}
        </p>
        <Link
          to="/"
          className="py-2 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg bg-[var(--color-accent)] text-white hover:bg-[var(--color-accent-hover)] focus:outline-hidden focus:ring-2 focus:ring-[var(--color-accent)] focus:ring-offset-2 transition-colors"
        >
          {t('core.notFound.backHome')}
        </Link>
      </div>
    </div>
  );
}
